export default __webpack_public_path__ + "static/media/stage_waiting.515f7100.svg";